// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';

export const updateFailedModeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'failureMode',
    type: actions.UPDATE_CLAIM_WEAR_PARTS_FAILED_MODE
});

export const updateDownTimeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'downtime',
    type: actions.UPDATE_CLAIM_WEAR_PARTS_DOWN_TIME
});

export const updateWearPartsClaimFailedArea = value => ({
    property: 'failureArea',
    type: actions.UPDATE_CLAIM_WEAR_PARTS_FAILED_AREA,
    value
});

export const updateWearPartsClaimPartSerialNumber = value => ({
    property: 'failurePartSerialNumber',
    type: actions.UPDATE_CLAIM_WEAR_PARTS_PART_SERIAL_NUMBER,
    value
});

export const updateWearPartsClaimFailedModeComments = value => ({
    property: 'failureModeComments',
    type: actions.UPDATE_CLAIM_WEAR_PARTS_FAILED_MODE_COMMENTS,
    value
});

export const updateWearPartsClaimDtacCase = value => ({
    property: 'dtacCase',
    type: actions.UPDATE_CLAIM_WEAR_PARTS_DTAC_CASE,
    value
});

export const updateWearPartsClaimDtacSolution = value => ({
    property: 'dtacSolution',
    type: actions.UPDATE_CLAIM_WEAR_PARTS_DTAC_SOLUTION,
    value
});

export const updateWearPartsClaimOperatorsComplaint = value => ({
    property: 'operatorsComplaint',
    type: actions.UPDATE_CLAIM_WEAR_PARTS_OPERATORS_COMPLAINT,
    value
});

export const updateWearPartsClaimComplaintCause = value => ({
    property: 'causeOfComplaining',
    type: actions.UPDATE_CLAIM_WEAR_PARTS_COMPLAINT_CAUSE,
    value
});

export const updateWearPartsClaimComplaintCorrection = value => ({
    property: 'howWasComplaintCorrected',
    type: actions.UPDATE_CLAIM_WEAR_PARTS_COMPLAINT_CORRECTION,
    value
});

export const updateWearPartsClaimOperatorComments = value => ({
    property: 'comments',
    type: actions.UPDATE_CLAIM_WEAR_PARTS_OPERATORS_COMMENTS,
    value
});

export const updateWearPartsClaimBasisForSettlement = value => ({
    property: 'basisForSettlement',
    type: actions.UPDATE_CLAIM_WEAR_PARTS_BASIS_FOR_SETTLEMENT,
    value
});



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/failure-panel.js